(function() {
  'use strict';
  angular.module('common')
  .directive('customPopover', function($compile, localStorageService) {
    var texts = {
      popoverShownOnce: "Click Here to view information for a different member or plan.",
      claims:   "Navigate to Procedure History to access the Member's Claims."
    };
    var strats = {
      1: "top",
      2: "right"
    };
    var append = {
      1: "false",
      2: "true"
    };
    return {
      restrict: "A",
      link: function($scope, element, attrs) {
        if(localStorageService.get(attrs.customPopover) !== true) {
          element.removeAttr('custom-popover');
          attrs.$set('popover-placement', strats[attrs.strategy]);
          attrs.$set('popover-append-to-body', append[attrs.strategy]);
          attrs.$set('popover-class', "popover-style-class hidden-print");
          attrs.$set('popover-enable', "true");
          attrs.$set('uib-popover', texts[attrs.customPopover]);
          attrs.$set('popover-trigger',"'click outsideClick'");
          attrs.$set('popover-is-open', "true");
          attrs.$set('popover-popup-delay', "2000");
          element.replaceWith($compile(element)($scope));
          localStorageService.set(attrs.customPopover, true);
        }
      }
     };
  });
})();
